import { supabase } from "@/lib/supabase/browser-client"
import { createIsomorphicLogger } from '@/utils/logger/isomorphicLogger'
import { logError } from '@/utils/errorLogging'

const logger = createIsomorphicLogger('base.tenantViews')

type ViewName =
  | "assistant_tenant_vw"
  | "chat_tenant_vw"
  | "collection_tenant_vw"
  | "file_tenant_vw"
  | "folder_tenant_vw"
  | "group_tenant_vw"
  | "mcp_tenant_vw"
  | "model_tenant_vw"
  | "preset_tenant_vw"
  | "profile_tenant_vw"
  | "prompt_tenant_vw"
  | "tool_tenant_vw"

export type ViewData = {
	tenant_id: any
	user_id: any
	sharing: any
} | null

const getTableTenantById = async (viewName: ViewName, refId: string): Promise<ViewData> => {
	const { data: viewData, error } = await supabase
		.from(viewName)
		.select("tenant_id, user_id, sharing")
		.eq("id", refId)
		.maybeSingle()

	if (!viewData) {
		if (error) {
			logError(logger, error, `Error getting table tenant by id for view:${viewName}, id:${refId}, error:${error.message}`)
		}
		return {
			tenant_id: '',
    	user_id: '',
    	sharing: ''
		}
	}
	return viewData
}

export const getAssistantTenantById = async (refId: string) => {
	return await getTableTenantById("assistant_tenant_vw", refId)
}

export const getChatTenantById = async (refId: string) => {
	return await getTableTenantById("chat_tenant_vw", refId)
}

export const getCollectionTenantById = async (refId: string) => {
	return await getTableTenantById("collection_tenant_vw", refId)
}

export const getFileTenantById = async (refId: string) => {
	return await getTableTenantById("file_tenant_vw", refId)
}

export const getFolderTenantById = async (refId: string) => {
	return await getTableTenantById("folder_tenant_vw", refId)
}

export const getGroupTenantById = async (refId: string) => {
	return await getTableTenantById("group_tenant_vw", refId)
}

export const getModelTenantById = async (refId: string) => {
	return await getTableTenantById("model_tenant_vw", refId)
}

export const getPresetTenantById = async (refId: string) => {
	return await getTableTenantById("preset_tenant_vw", refId)
}

export const getProfileTenantById = async (refId: string) => {
	return await getTableTenantById("profile_tenant_vw", refId)
}

export const getPromptTenantById = async (refId: string) => {
	return await getTableTenantById("prompt_tenant_vw", refId)
}

export const getMcpTenantById = async (refId: string) => {
	return await getTableTenantById("mcp_tenant_vw", refId)
}

export const getToolTenantById = async (refId: string) => {
	return await getTableTenantById("tool_tenant_vw", refId)
}

export const getWorkspacesTenantById = async (refId: string) => {
	const { data: viewData, error } = await supabase
		.from("workspaces")
		.select("tenant_id, user_id, sharing")
		.eq("id", refId)
		.maybeSingle()

	if (!viewData) {
		if (error) {
			logError(logger, error, `Error getting worksapce tenant, id:${refId}, error:${error.message}`)
		}
		return {
			tenant_id: '',
    	user_id: '',
    	sharing: ''
		}
	}
	return viewData
}
